export const isAuthenticated = (state) => {
    // Check for idToken or access_token in state, or check localStorage
    const hasTokenInState = !!(state.auth.auth.idToken || state.auth.auth.access_token);
    console.log('🔍 [isAuthenticated] Checking Redux state:', { 
        idToken: state.auth.auth.idToken ? 'present' : 'missing',
        access_token: state.auth.auth.access_token ? 'present' : 'missing',
        hasTokenInState 
    });
    
    if (hasTokenInState) {
        console.log('✅ [isAuthenticated] Token found in Redux state, returning true');
        return true;
    }
    
    // Fallback: check localStorage for token
    const userDetails = localStorage.getItem('userDetails');
    console.log('🔍 [isAuthenticated] Checking localStorage:', { userDetails: userDetails ? 'present' : 'missing' });
    if (userDetails) {
        try {
            const parsed = JSON.parse(userDetails);
            const hasTokenInLocalStorage = !!(parsed.access_token || parsed.idToken);
            console.log('🔍 [isAuthenticated] Parsed localStorage:', { 
                access_token: parsed.access_token ? 'present' : 'missing',
                idToken: parsed.idToken ? 'present' : 'missing',
                hasTokenInLocalStorage 
            });
            if (hasTokenInLocalStorage) {
                console.log('✅ [isAuthenticated] Token found in localStorage, returning true');
                return true;
            }
        } catch (e) {
            console.error('❌ [isAuthenticated] Error parsing localStorage:', e);
        }
    }
    
    console.log('❌ [isAuthenticated] No token found, returning false');
    return false;
};
